const PreperedIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.2"
        width="36.8348"
        height="37.0051"
        rx="18.4174"
        fill="#CB3CFF"
      />
      <path
        d="M13 28C12.45 28 11.9792 27.8042 11.5875 27.4125C11.1958 27.0208 11 26.55 11 26V14C11 13.45 11.1958 12.9792 11.5875 12.5875C11.9792 12.1958 12.45 12 13 12H15C15 10.9 15.3917 9.95833 16.175 9.175C16.9583 8.39167 17.9 8 19 8C20.1 8 21.0417 8.39167 21.825 9.175C22.6083 9.95833 23 10.9 23 12H25C25.55 12 26.0208 12.1958 26.4125 12.5875C26.8042 12.9792 27 13.45 27 14V26C27 26.55 26.8042 27.0208 26.4125 27.4125C26.0208 27.8042 25.55 28 25 28H13ZM13 26H25V14H23V16C23 16.2833 22.9042 16.5208 22.7125 16.7125C22.5208 16.9042 22.2833 17 22 17C21.7167 17 21.4792 16.9042 21.2875 16.7125C21.0958 16.5208 21 16.2833 21 16V14H17V16C17 16.2833 16.9042 16.5208 16.7125 16.7125C16.5208 16.9042 16.2833 17 16 17C15.7167 17 15.4792 16.9042 15.2875 16.7125C15.0958 16.5208 15 16.2833 15 16V14H13V26ZM17 12H21C21 11.45 20.8042 10.9792 20.4125 10.5875C20.0208 10.1958 19.55 10 19 10C18.45 10 17.9792 10.1958 17.5875 10.5875C17.1958 10.9792 17 11.45 17 12Z"
        fill="#CB3CFF"
      />
    </svg>
  );
};

export default PreperedIcon;
